import { motion } from "framer-motion";

// Standard scroll-reveal fade-up
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

// Staggered container
export const StaggerGroup = ({ children, className = "", stagger = 0.12 }) => (
    <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={{
            hidden: {},
            show: { transition: { staggerChildren: stagger } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
    <motion.div
        variants={{
            hidden: { opacity: 0, y },
            show: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
            },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

// Masked line-by-line reveal for large display headings.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
    <div className={className}>
        {lines.map((line, i) => (
            <div key={i} className="overflow-hidden">
                <motion.div
                    initial={{ y: "110%" }}
                    animate={{ y: 0 }}
                    transition={{
                        duration: 1,
                        delay: delay + i * 0.14,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    className={lineClassName}
                >
                    {line}
                </motion.div>
            </div>
        ))}
    </div>
);

// Section eyebrow label with numbering
export const SectionLabel = ({ index, children }) => (
    <div className="flex items-center gap-4 mb-6">
        {index && (
            <span className="font-mono text-xs text-gold tracking-[0.25em]">
                {index}
            </span>
        )}
        <span className="h-px w-10 bg-gold/50" />
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/60">
            {children}
        </span>
    </div>
);
